import { IBaseResponseModel } from "../../models/common/models.type";
import {
  ILoginResponse,
  IGoogleLoginRequest,
  IEmailLoginRequest,
} from "../../models/auth";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";

const API_AUTH = ApiEndpoints.AUTH;
const baseURL = envConfig.API_ENDPOINT;

const loginWithGoogleMail = async (
  login: IGoogleLoginRequest,
): Promise<IBaseResponseModel<ILoginResponse>> => {
  const res = await api.post<
    IGoogleLoginRequest,
    IBaseResponseModel<ILoginResponse>
  >(baseURL, API_AUTH.LOGIN_WITH_GOOLE_GMAIL.url, login);
  return res;
};

const loginWithMail = async (
  login: IEmailLoginRequest,
): Promise<IBaseResponseModel<ILoginResponse>> => {
  const res = await api.post<
    IEmailLoginRequest,
    IBaseResponseModel<ILoginResponse>
  >(baseURL, API_AUTH.LOGIN_WITH_GMAIL.url, login);
  return res;
};

const adminLoginWithEmail = async (
  login: IGoogleLoginRequest,
): Promise<IBaseResponseModel<ILoginResponse>> => {
  const res = await api.post<
    IGoogleLoginRequest,
    IBaseResponseModel<ILoginResponse>
  >(baseURL, API_AUTH.Admin_LOGIN_WITH_GMAIL.url, login);
  return res;
};

const AuthService = {
  adminLoginWithEmail,
  loginWithGoogleMail,
  loginWithMail,
};

export default AuthService;
